<div class="sw-zone-panel">

  <!-- HEADER — omitted when embedded; the host <sw-drawer> provides the chrome. -->
  @if (!embedded) {
  <div class="sw-zone-header">
    <h2 class="sw-zone-title">Site Camera Create Zone</h2>
    <button type="button" class="sw-zone-close" aria-label="Close" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  }

  <!-- BODY -->
  <div class="sw-zone-body">
    <div class="sw-zone-controls">
      <button type="button" class="sw-zone-btn sw-zone-btn--grey" (click)="undo(); $event.preventDefault()"
        title="Undo (Ctrl+Z)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 10h10a5 5 0 0 1 0 10H8"></path>
          <path d="m7 5-4 5 4 5"></path>
        </svg>
        Undo
      </button>
      <button type="button" class="sw-zone-btn sw-zone-btn--grey" (click)="redo()" title="Redo (Ctrl+Y)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10H11a5 5 0 0 0 0 10h5"></path>
          <path d="m17 5 4 5-4 5"></path>
        </svg>
        Redo
      </button>
      <button type="button" class="sw-zone-btn sw-zone-btn--danger" (click)="clearAllZones()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
        Clear
      </button>
    </div>

    <div class="sw-zone-canvas-wrap">
      <canvas id="zone-canvas" [width]="canvasWidth" [height]="canvasHeight" class="sw-zone-canvas"></canvas>
      @if (!imageLoaded) {
      <div class="sw-zone-canvas-loading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- FOOTER -->
  <div class="sw-zone-footer">
    <button type="button" class="sw-zone-action sw-zone-action--discard" (click)="closeModal()">Discard</button>
    <button type="button" class="sw-zone-action sw-zone-action--save" (click)="saveAllZones()">Save</button>
  </div>
</div>
